import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface ApplyGiftCardToCartMutationObject {
  mutation: {
    applyGiftCardToCart: {
      __args: {
        input: {
          cart_id: string
          gift_card_code: string
          [key: string]: any
        }
      }
      [key: string]: any
    }
  }
}

export const applyGiftCardToCartMutationObject: ApplyGiftCardToCartMutationObject = {
  mutation: {
    applyGiftCardToCart: {
      __args: {
        input: {
          cart_id: '',
          gift_card_code: ''
        }
      }
    }
  }
}

interface ApplyGiftCardToCartMutationInput {
  cartId: string
  giftCard: string
}

export type ApplyGiftCardToCartMutation = (input: ApplyGiftCardToCartMutationInput) => Promise<FetchResult<any>>

export const createApplyGiftCardToCartMutation = ({ getMutations, getQueries }: ServiceDependencies): ApplyGiftCardToCartMutation => async ({ cartId, giftCard }) => {
  const queries = getQueries()
  const mutation = getMutations().applyGiftCardToCartMutation
  mutation.mutation.applyGiftCardToCart.__args.input.cart_id = cartId
  mutation.mutation.applyGiftCardToCart.__args.input.gift_card_code = giftCard
  mutation.mutation.applyGiftCardToCart = {
    ...mutation.mutation.applyGiftCardToCart,
    cart: {
      ...queries.cartQuery,
      ...queries.cartPrices,
      ...queries.shippingAddresses,
      ...queries.billingAddresses,
      ...queries.cartAppliedCoupon
    }
  }

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
